import { render } from "./deletlogscomp.vue?vue&type=template&id=492d8d80"
import script from "./deletlogscomp.vue?vue&type=script&lang=js"
export * from "./deletlogscomp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__